// extracted by mini-css-extract-plugin
export var alternate = "_1u-j";
export var black = "_1u-6";
export var blue = "_1u-f";
export var blueLight = "_1u-e";
export var brand = "_1u-8";
export var darkMode = "_1u-b";
export var error = "_1u-a";
export var gray = "_1u-5";
export var grayBlue = "_1u-d";
export var iconWrapper = "_1u-3";
export var inactive = "_1u-7";
export var indigo = "_1u-g";
export var orange = "_1u-i";
export var pink = "_1u-h";
export var primary = "_1u-0";
export var purple = "_1u-9";
export var success = "_1u-4";
export var warning = "_1u-c";
export var white = "_1u-1";
export var whiteSuccess = "_1u-2";